export function getInicio(urlInicio) {
	return fetch(`${urlInicio}`)
		.then((res) => res.json())
		.then((data) => data)
		.catch((error) => {
			return error;
		});
}

export function getObtenerFlagCorreo(context) {
  return fetch(`${context}obtenerFlagCorreo`)
  .then(res => res.json())
  .then(data => data)
	.catch((error) => {
		return error;
	});
}

export function postGuardarDatosBasicos(context, bodyRequest) {
  return fetch(`${context}guardarDatosBasicos`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyRequest),
  })
    .then((res) => res.json())
    .then((data) => data)
		.catch((error) => {
			return error;
		});
}

export function postObtenerStock(context, bodyRequest) {
  return fetch(`${context}obtenerStock`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyRequest),
  })
    .then((res) => res.json())
    .then((data) => data)
		.catch((error) => {
			return error;
		});
}

export function postGuardarTipoCuenta(context, bodyRequest) {
  return fetch(`${context}guardarTipoCuenta`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyRequest),
  })
    .then((res) => res.json())
    .then((data) => data)
		.catch((error) => {
			return error;
		});
}

export function postGuardarDireccion(context, bodyRequest) {
  return fetch(`${context}guardarDireccion`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyRequest),
  })
    .then((res) => res.json())
    .then((data) => data)
		.catch((error) => {
			return error;
		});
}

export function postReenviarSMS(context, bodyRequest) {
  return fetch(`${context}reenviarSMS`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyRequest),
  })
    .then((res) => res.json())
    .then((data) => data)
		.catch((error) => {
			return error;
		});
}

export function postConfirmarSolicitud(context, bodyRequest) {
  return fetch(`${context}confirmarSolicitud`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyRequest),
  })
    .then((res) => res.json())
    .then((data) => data)
		.catch((error) => {
			return error;
		});
}

export function postObtenerCrossSell(context, bodyRequest) {
  return fetch(`${context}obtenerCrossSell`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyRequest),
  })
    .then((res) => res.json())
    .then((data) => data)
		.catch((error) => {
			return error;
		});
}